import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const FormatPage = loadAsyncComponent(() => import('./Container'), 'page');
